let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qLFz")).then(() => parcelRequire('3Vnrm'));